import { ChainId } from '@src/configs/chainInfo'
import { TronAddress } from '@src/types/token'
import { getEvmAllowance } from '@src/utils/evm/getAllowance'
import { walletLogger } from '@src/utils/logger'
import { getSolanaAllowance } from '@src/utils/solana/getAllowance'
import { getTronChainAllowance } from '@src/utils/tron/getAllowance'

export const getAllowance = async (
    chainId: number,
    address?: string,
    owner?: string | null,
    spender?: string
): Promise<bigint> => {
    // walletLogger.debug('getAllowance called with:', {
    //     chainId,
    //     address,
    //     owner,
    //     spender,
    // })

    if (!address || !spender || !owner) {
        walletLogger.debug('Returning 0 because of missing arguments')
        return BigInt(0)
    }

    switch (chainId) {
        case ChainId.Solana:
            return getSolanaAllowance(address, owner, spender)

        case ChainId.Tron:
            return getTronChainAllowance(address as TronAddress, owner, spender)

        default:
            return getEvmAllowance(address as `0x${string}`, owner as `0x${string}`, spender as `0x${string}`, chainId)
    }
}
